export const questionsForMainGuest = [
  'receipt_address', 'signature', 'face_recognition',
];